export function getFetchArguments(endpoint, params, body) {
    return {
        endpoint,
        params,
        body: JSON.stringify(body),
        config: getFetchConfig(),
        responseInterceptor,
        errorInterceptor,
    };
}

/**
 * Form-encoded variant, for the OAuth2 token endpoint (CM-1805). That endpoint takes
 * application/x-www-form-urlencoded because RFC 6749 says so, not because we chose it — the JSON
 * arguments above will not do.
 *
 * credentials: 'include' matters here specifically: the exchange only succeeds if the browser sends
 * back the VfSsoNonce cookie the initiator set.
 */
export function getFormFetchArguments(endpoint, params, fields) {
    return {
        endpoint,
        params,
        body: new URLSearchParams(fields).toString(),
        config: getFormFetchConfig(),
        responseInterceptor,
        errorInterceptor,
    };
}

function getFetchConfig() {
    return {
        credentials: 'include',
        mode: 'cors',
        headers: {
            'accept': 'application/json',
            'content-type': 'application/json;charset=UTF-8',
        },
    };
}

function getFormFetchConfig() {
    return {
        credentials: 'include',
        mode: 'cors',
        headers: {
            'accept': 'application/json',
            'content-type': 'application/x-www-form-urlencoded;charset=UTF-8',
        },
    };
}

function responseInterceptor(request, response) {
    if (response.ok) {
        if (!Number(response.headers.get('Content-Length'))) {
            return Promise.resolve(response);
        }

        return response.json()
            .then((data) => {
                response.data = data;
                return response;
            });
    }
    return Promise.reject(response);
}


function errorInterceptor(request, response) {
    return Promise.reject(response);
}
